// Environment validation to prevent runtime errors
export const validateEnvironment = () => {
  const required = {
    REACT_APP_SUPABASE_URL: process.env.REACT_APP_SUPABASE_URL,
    REACT_APP_SUPABASE_ANON_KEY: process.env.REACT_APP_SUPABASE_ANON_KEY,
  };

  const missing: string[] = [];

  Object.entries(required).forEach(([key, value]) => {
    if (!value) {
      missing.push(key);
    }
  });

  return {
    isValid: missing.length === 0,
    missing,
    hasSupabase: !!(required.REACT_APP_SUPABASE_URL && required.REACT_APP_SUPABASE_ANON_KEY),
  };
};
